<script lang="ts">
  import { onMount } from "svelte";
  import { orgClose } from "@nrk/origo";

  export let id: string;
  export let confirmText: string;
  export let loadingText: string | undefined = undefined;
  export let headerText: string;
  export let onConfirm: () => void | Promise<void>;
  export let onOpen: (() => void) | undefined = undefined;
  export let confirmDisabled: boolean = false;

  let dialogElement: HTMLElement;
  let saving = false;

  onMount(() => {
    if (!onOpen) return;
    const observer = new MutationObserver(() => {
      if (!dialogElement.hidden) onOpen?.();
    });
    observer.observe(dialogElement, { attributes: true, attributeFilter: ["hidden"] });
    return () => observer.disconnect();
  });

  async function handleConfirm() {
    saving = true;
    try {
      await onConfirm();
      if (dialogElement) {
        dialogElement.hidden = true;
      }
    } finally {
      saving = false;
    }
  }
</script>

<bb-dialog {id} hidden bind:this={dialogElement} role="dialog">
  <header class="org-bar org-bar--primary">
    <h1>{headerText}</h1>
    <button class="org-button close-button" data-for="close">
      {@html orgClose}
      <span class="org-sr">Lukk dialogen</span>
    </button>
  </header>
  <form on:submit|preventDefault={handleConfirm}>
    <div class="message">
      <slot />
    </div>
    <div class="dialog-toolbar">
      <div>
        <slot name="toolbar-buttons-left" />
      </div>
      <div class="toolbar-right">
        <button type="button" class="org-button org-button--secondary" data-for="close">
          Avbryt</button
        >
        <button
          type="submit"
          class="org-button org-button--primary"
          data-testid="delete-image-confirm"
          aria-busy={saving}
          disabled={saving || confirmDisabled}
        >
          {saving ? loadingText ?? confirmText : confirmText}
        </button>
        <slot name="toolbar-buttons-right" />
      </div>
    </div>
  </form>
</bb-dialog>

<style>
  bb-dialog {
    width: 600px;
    max-width: 90vw;
    min-height: 200px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    gap: var(--org-small);
    background-color: var(--color-surface-tertiary);
    color: var(--color-text-primary);
  }

  header {
    flex-shrink: 0;
    background-color: var(--color-surface-primary);
    color: var(--color-text-primary);
  }

  .message {
    flex: 1;
    overflow-y: auto;
    padding: 0 var(--org-medium);
  }

  .dialog-toolbar {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: var(--org-medium);
  }

  .toolbar-right {
    display: flex;
    gap: var(--org-xsmall);
  }

  .close-button {
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
